import { Resource as e } from "@coveo/platform-client";
const a = class a extends e {
  /**
   * List available query pipeline settings.
   *
   * @returns {Promise<PageModel<AvailablePipelineSettings>>} The list of available query pipeline settings.
   */
  listAvailableSettings(t) {
    return this.api.get(
      this.buildPath(`${a.baseUrl}/settings/metadata`, {
        ...t,
        organizationId: this.api.organizationId
      })
    );
  }
  /**
   * List settings for a specific pipeline.
   *
   * @param {string} pipelineId The unique identifier of the target query pipeline.
   * @param {ListPipelineSettingsParams} params A set of parameters to customize the results.
   *
   * @returns {Promise<PageModel<PipelineSettingResponse>>} The list of query pipeline settings.
   */
  list(t, i) {
    return this.api.get(
      this.buildPath(`${a.baseUrl}/${t}/settings`, {
        ...i,
        organizationId: this.api.organizationId
      })
    );
  }
  /**
   * Read a setting for a specific pipeline.
   *
   * @param {string} pipelineId The unique identifier of the target query pipeline.
   * @param {string} settingsId The unique identifier of the query pipeline setting.
   *
   * @returns {Promise<PipelineSettingResponse>} The query pipeline setting.
   */
  get(t, i) {
    return this.api.get(
      this.buildPath(`${a.baseUrl}/${t}/settings/${i}`, {
        organizationId: this.api.organizationId
      })
    );
  }
  /**
   * Create a setting for a specific pipeline.
   *
   * @param {string}pipelineId The unique identifier of the target query pipeline.
   *
   * @returns {Promise<PipelineSettingResponse>} The created query pipeline setting.
   */
  create(t, i) {
    return this.api.post(
      this.buildPath(`${a.baseUrl}/${t}/settings`, {
        organizationId: this.api.organizationId
      }),
      i
    );
  }
  /**
   * Update a setting for a specific pipeline.
   *
   * @param {string} pipelineId The unique identifier of the target query pipeline.
   * @param {string} settingsId The unique identifier of the query pipeline setting.
   *
   * @returns {Promise<PipelineSettingResponse>} The updated query pipeline setting.
   */
  update(t, i, s) {
    return this.api.put(
      this.buildPath(`${a.baseUrl}/${t}/settings/${i}`, {
        organizationId: this.api.organizationId
      }),
      s
    );
  }
  /**
   * Delete a setting.
   *
   * @param {string} pipelineId The unique identifier of the target query pipeline.
   * @param {string} settingsId The unique identifier of the query pipeline setting.
   *
   * @returns {Promise<void>}
   */
  delete(t, i) {
    return this.api.delete(
      this.buildPath(`${a.baseUrl}/${t}/settings/${i}`, {
        organizationId: this.api.organizationId
      })
    );
  }
  /**
   * Bulk delete settings.
   *
   * @param {string} pipelineId The unique identifier of the target query pipeline.
   * @param {string[]} ids The query pipeline settings to delete.
   */
  bulkDelete(t, i) {
    return this.api.post(
      this.buildPath(`${a.baseUrl}/${t}/settings/bulkDelete`, {
        organizationId: this.api.organizationId
      }),
      { ids: i }
    );
  }
  /**
   * Bulk get settings for a specific pipeline.
   *
   * @param {string} pipelineId The unique identifier of the target query pipeline.
   * @param {BulkGetPipelineSettingsParams} params A set of parameters to customize the results.
   *
   * @returns The list of query pipeline settings.
   */
  bulkGet(t, { ids: i, ...s }) {
    return this.api.post(
      this.buildPath(`${a.baseUrl}/${t}/settings/bulkGet`, {
        organizationId: this.api.organizationId,
        ...s
      }),
      { ids: i }
    );
  }
  /**
   * Copies specific settings from an origin to a target query pipeline. Using the same pipeline as origin and target will duplicate the specified settings in that pipeline.
   *
   * @param {string} pipelineId The unique identifier of the target query pipeline.
   * @param {CopyPipelineSettingsRequest} request The information about the settings to copy.
   *
   * @returns {Promise<CopyPipelineSettingsResponse>} The copied query pipeline settings.
   */
  copy(t, i) {
    return this.api.post(
      this.buildPath(`${a.baseUrl}/${t}/settings/copy`, {
        organizationId: this.api.organizationId
      }),
      i
    );
  }
  /**
   * Move a setting.
   *
   * @param {string} pipelineId The unique identifier of the target query pipeline.
   * @param {string} settingId The unique identifier of the query pipeline setting.
   * @param {MoveSettingRequest} request The information about the setting to move.
   *
   * @returns {Promise<void>}
   */
  move(t, i, s) {
    return this.api.put(
      this.buildPath(`${a.baseUrl}/${t}/settings/${i}/move`, {
        organizationId: this.api.organizationId
      }),
      s
    );
  }
};
a.baseUrl = "/rest/search/v2/admin/pipelines";
let n = a;
export {
  n as PipelineSettingsResource
};
//# sourceMappingURL=PipelineSettingsResource.js.map
